import { Link, useLocation } from 'react-router-dom';
import { APP_CONFIG } from '../../constants/appConfig';

const AgentSidebar = ({ user, sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();
  
  const menuItems = [
    { 
      icon: 'fas fa-tachometer-alt', 
      label: 'Dashboard', 
      path: '/agent/dashboard',
    },
    { 
      icon: 'fas fa-search', 
      label: 'Search Hotel', 
      path: '/agent/dashboard/searchhotel',
    },
    { 
      icon: 'fas fa-history', 
      label: 'Search History', 
      path: '/agent/dashboard/searchhistory',
    },
    { 
      icon: 'fas fa-coins', 
      label: 'Token Accounts', 
      path: '/agent/dashboard/tokenrecharge',
    },
    { 
      icon: 'fas fa-list-alt', 
      label: 'Booking Details', 
      path: '/agent/dashboard/bookingdetails',
    },
    { 
      icon: 'fas fa-times-circle', 
      label: 'Booking Cancellation', 
      path: '/agent/dashboard/bookingcancellation',
    },
    { 
      icon: 'fas fa-clock', 
      label: 'Booking History', 
      path: '/agent/dashboard/bookinghistory',
    },
    { 
      icon: 'fas fa-credit-card', 
      label: 'Payment Information', 
      path: '/agent/dashboard/paymentinfo',
    },
    { 
      icon: 'fas fa-hand-holding-usd', 
      label: 'Manual Payment', 
      path: '/agent/dashboard/manualpayment',
    },
    { 
      icon: 'fas fa-ticket-alt', 
      label: 'Support Ticket', 
      path: '/agent/dashboard/supportticket',
    },
    /*
    { 
      icon: 'fas fa-history', 
      label: 'Token Recharge History', 
      path: '/agent/dashboard/tokenhistory',
    },
    */
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Sidebar */}
      <aside className={`fixed lg:fixed inset-y-0 left-0 z-40 ${sidebarOpen ? 'w-64' : 'w-16'} bg-white shadow-lg transition-all duration-300 ease-in-out`}>
        <div className="flex flex-col h-full">
          {/* Sidebar Header with Toggle */}
          <div className={`flex items-center ${sidebarOpen ? 'justify-between' : 'justify-center'} p-4 border-b border-gray-200`}>
            {sidebarOpen && <h3 className="text-lg font-semibold text-gray-900">Navigation</h3>}
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 rounded-lg text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors duration-200"
              title={sidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={sidebarOpen ? "M15 19l-7-7 7-7" : "M9 5l7 7-7 7"} />
              </svg>
            </button>
          </div>

          {/* User Info */}
          <div className={`${sidebarOpen ? 'p-6' : 'p-2'} border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50`}>
            <div className="text-center">
              <div className={`${sidebarOpen ? 'w-16 h-16' : 'w-10 h-10'} bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto ${sidebarOpen ? 'mb-3' : 'mb-0'} transition-all duration-300`}>
                <i className={`fas fa-user text-white ${sidebarOpen ? 'text-2xl' : 'text-lg'}`}></i>
              </div>
              {sidebarOpen && (
                <div className="transition-opacity duration-300">
                  <p className="text-sm text-gray-600">Logged in as</p>
                  <p className="font-semibold text-gray-900">{user?.firstName} {user?.lastName}</p>
                  <p className="text-sm text-blue-600 font-medium">{user?.role?.replace('ROLE_', '')}</p>
                  {user?.agentId && (
                    <p className="text-xs text-gray-500 mt-1">ID: {user.agentId}</p>
                  )}
                </div>
              )}
            </div>
          </div>
          
          {/* Navigation Menu */}
          <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
            {menuItems.map((item, index) => (
              <Link
                key={index}
                to={item.path}
                onClick={() => {
                  // Close sidebar on mobile after navigation
                  if (window.innerWidth < 1024) {
                    setSidebarOpen(false);
                  }
                }}
                className={`w-full flex items-center ${sidebarOpen ? 'px-4 py-3' : 'px-2 py-3 justify-center'} text-sm font-medium rounded-lg transition-all duration-200 ${
                  isActive(item.path)
                    ? 'text-blue-600 bg-blue-50 border-r-2 border-blue-600'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                }`}
                title={!sidebarOpen ? item.label : ''}
              >
                <i className={`${item.icon} ${sidebarOpen ? 'w-5 h-5 mr-3' : 'w-5 h-5'} ${isActive(item.path) ? 'text-blue-600' : 'text-gray-400'}`}></i>
                {sidebarOpen && (
                  <span className="transition-opacity duration-300">{item.label}</span>
                )}
              </Link>
            ))}
          </nav>

          {/* Footer */}
          {sidebarOpen && (
            <div className="p-4 border-t border-gray-200 bg-gray-50 transition-opacity duration-300">
              <div className="text-center text-xs text-gray-500">
                <p>{APP_CONFIG.copyrightText}</p>
                <p>{APP_CONFIG.appName}</p>
              </div>
            </div>
          )}
        </div>
      </aside>

      {/* Overlay for mobile */}
      {sidebarOpen && window.innerWidth < 1024 && (
        <div 
          className="lg:hidden fixed inset-0 z-30 bg-black bg-opacity-50 transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
    </>
  );
};

export default AgentSidebar;